class BuyButtons extends HTMLElement {
    static observedAttributes = ['color', 'clientWidth']
    constructor() {
      super()
      this.observeSelectedVariantAttribute();
    }
    
    observeSelectedVariantAttribute() {
      const closestElement = this.closest('[data-product-card-selected_variant_id]');
      
      if (!closestElement) {
        console.error("No ancestor element found with 'data-product-card-selected_variant_id' attribute.");
        return;
      }
      const observer = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant_id') {
            const newValue = closestElement.getAttribute('data-product-card-selected_variant_id');
            if (newValue) {
              this.showButton(newValue);
            }
          }
        }
      });
      observer.observe(closestElement, { attributes: true });
    }

    showButton(newValue){
        const buttons = this.querySelectorAll("[data-buy-buttons]");

        buttons.forEach((button) => {
            button.classList.add("hidden");
        })

        buttons.forEach((button) => {
            const variant = button.getAttribute('data-target-variant')

            if(variant == newValue){
                button.classList.remove("hidden");
                button.classList.add("block");
            }
        })
    }
}
customElements.define('buy-buttons', BuyButtons)
  